// extracted by mini-css-extract-plugin
export const outer = "about-css-modules-module--outer--3kTlo";
export const inner = "about-css-modules-module--inner--135Le";
export const light = "about-css-modules-module--light--3yyYp";
export const dark = "about-css-modules-module--dark--Axl5G";
export const gif = "about-css-modules-module--gif--3Ttwk";